var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB4ASqaureGlowLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2523_22722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 29.5C28 28.3954 28.8954 27.5 30 27.5H50C51.1046 27.5 52 28.3954 52 29.5V49.5C52 50.6046 51.1046 51.5 50 51.5H30C28.8954 51.5 28 50.6046 28 49.5V29.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 29.5C28 28.3954 28.8954 27.5 30 27.5H50C51.1046 27.5 52 28.3954 52 29.5V49.5C52 50.6046 51.1046 51.5 50 51.5H30C28.8954 51.5 28 50.6046 28 49.5V29.5Z",
    fill: "url(#paint0_linear_2523_22722)",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5203 43.7947C33.022 43.7947 32.5832 43.6905 32.2039 43.4823C31.8245 43.2666 31.527 42.9542 31.3113 42.5451C31.0957 42.1361 30.9767 41.6415 30.9543 41.0613H31.1886V43.5938H29.9614V35.4497H31.5122V39.5218L31.0994 40.1577C31.1291 39.5329 31.2518 39.0123 31.4675 38.5958C31.6907 38.1793 31.9882 37.8669 32.36 37.6587C32.7319 37.4504 33.1521 37.3463 33.6207 37.3463C34.0372 37.3463 34.4165 37.4244 34.7587 37.5806C35.1008 37.7367 35.3946 37.9562 35.64 38.2388C35.8855 38.514 36.0714 38.8375 36.1978 39.2094C36.3317 39.5813 36.3986 39.9866 36.3986 40.4254V40.6597C36.3986 41.0985 36.3317 41.5076 36.1978 41.8869C36.064 42.2662 35.8706 42.6009 35.6177 42.891C35.3648 43.1736 35.0599 43.3967 34.7029 43.5604C34.3533 43.7166 33.9591 43.7947 33.5203 43.7947ZM33.1745 42.4894C33.5091 42.4894 33.7992 42.4075 34.0447 42.2439C34.2975 42.0729 34.4946 41.8423 34.6359 41.5522C34.7773 41.2622 34.8479 40.9275 34.8479 40.5481C34.8479 40.1614 34.7773 39.8267 34.6359 39.5441C34.4946 39.2614 34.2975 39.042 34.0447 38.8859C33.7992 38.7297 33.5091 38.6516 33.1745 38.6516C32.8695 38.6516 32.5869 38.7185 32.3266 38.8524C32.0737 38.9863 31.8654 39.1834 31.7018 39.4437C31.5456 39.704 31.4675 40.0164 31.4675 40.3808V40.8271C31.4675 41.1766 31.5493 41.4741 31.713 41.7196C31.8766 41.965 32.0886 42.1547 32.3489 42.2885C32.6092 42.4224 32.8844 42.4894 33.1745 42.4894Z",
    fill: "#10203A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3048 41.9092V40.1911L40.4955 35.2266L41.6892 36.041L38.8778 40.4366L39.0117 40.6597H44.0097V41.9092H37.3048ZM41.5665 43.5938V37.7591H43.028V43.5938H41.5665Z",
    fill: "#10203A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8193 43.5938V41.7977H48.5627V39.8007C48.5627 39.4511 48.4772 39.1908 48.3061 39.0197C48.1351 38.8487 47.871 38.7631 47.514 38.7631C47.3281 38.7631 47.105 38.7668 46.8447 38.7743C46.5843 38.7817 46.3203 38.7929 46.0526 38.8078C45.7922 38.8152 45.558 38.8263 45.3497 38.8412V37.5248C45.5208 37.5099 45.7142 37.495 45.9298 37.4801C46.1455 37.4653 46.3649 37.4578 46.5881 37.4578C46.8186 37.4504 47.0343 37.4467 47.2351 37.4467C47.8599 37.4467 48.3768 37.5285 48.7859 37.6921C49.2024 37.8557 49.5148 38.1123 49.723 38.4619C49.9387 38.8115 50.0465 39.2689 50.0465 39.8341V43.5938H48.8193ZM46.867 43.75C46.4282 43.75 46.0414 43.6719 45.7067 43.5157C45.3795 43.3596 45.1229 43.1364 44.9369 42.8464C44.7584 42.5563 44.6692 42.2067 44.6692 41.7977C44.6692 41.3514 44.777 40.987 44.9927 40.7043C45.2158 40.4217 45.5245 40.2097 45.9187 40.0684C46.3203 39.9271 46.7889 39.8565 47.3244 39.8565H48.7301V40.7824H47.3021C46.9451 40.7824 46.6699 40.8717 46.4765 41.0502C46.2906 41.2212 46.1976 41.4444 46.1976 41.7196C46.1976 41.9948 46.2906 42.2179 46.4765 42.3889C46.6699 42.56 46.9451 42.6455 47.3021 42.6455C47.5178 42.6455 47.7149 42.6084 47.8934 42.534C48.0793 42.4522 48.2318 42.3183 48.3508 42.1324C48.4772 41.939 48.5479 41.6787 48.5627 41.3514L48.9421 41.7865C48.9049 42.2104 48.8007 42.5675 48.6297 42.8575C48.4661 43.1476 48.2355 43.3707 47.938 43.5269C47.6479 43.6756 47.2909 43.75 46.867 43.75Z",
    fill: "#10203A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2523_22722",
    x: 0.535021,
    y: 0.0350208,
    width: 78.93,
    height: 78.93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.7325
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.758333 0 0 0 0 0.885526 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2523_22722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.1972
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0986
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2523_22722",
    result: "effect2_dropShadow_2523_22722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2523_22722",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2523_22722",
    x1: 40,
    y1: 75.62,
    x2: 40,
    y2: 45.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB4ASqaureGlowLogo);
export default __webpack_public_path__ + "static/media/b4a-sqaure-glow-logo.2e077adc5beef32f767d7134ad9c1501.svg";
export { ForwardRef as ReactComponent };